module.exports = "<div id=\"home\"></div>\n<div id=\"dishome\"></div>\n<div id=\"hovdis\"></div>\n";